export default __webpack_public_path__ + "static/media/skill-anim-dark.afcd68cd.svg";